/**
 * @description: size引导组件
 * @author: zhouyh
 * @time: 2023/8/10 16:15
 */
import { youTuBeVideoWH } from "@/lib/commonService";
import React, { useEffect } from "react";
import styles from "./sizeGuider.module.scss"; // 导入 CSS Module 样式
import getWebpUrl from "@/src/utils/configUtils";
import { FmImage } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";

function td(tds: any) {
    return tds.map((e: any, key: any) => {
        return <td key={key}>{e}</td>;
    });
}

const SizeGuider: React.FC = () => {
    const { t } = useTranslation("common");

    useEffect(() => {
        const iframe = document.querySelector(".youtube-iframe");
        if (iframe) {
            youTuBeVideoWH(iframe, 560 / 315);
        }
    }, []);
    return (
        <div className={styles["size-guide-container"]}>
            <iframe
                title="size guide"
                className={styles["youtube-iframe"]}
                width="350px"
                height="200"
                src="https://www.youtube.com/embed/kFORMJkUrko"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />

            <p className={styles.title}>
                {t("common:SizeGuide:ExistingEyeglass")}
            </p>
            <p className={styles.describle}>
                {t("common:SizeGuide:ExistingEyeglassText")}
            </p>
            <FmImage
                image={getWebpUrl(t("common:SizeGuide:ExistingEyeglassImg"))}
                style={{ maxHeight: "1.9rem" }}
            />

            <p className={styles.title}>
                {t("common:SizeGuide:SuitableGlasses")}
            </p>
            <p className={styles.describle}>
                {t("common:SizeGuide:SuitableGlassesText1")}
                <br />
                {t("common:SizeGuide:SuitableGlassesText2")}
            </p>
            <div style={{ height: "5.5rem" }}>
                <FmImage
                    image={getWebpUrl(
                        t("common:SizeGuide:SuitableGlassesImg1"),
                    )}
                />
                <FmImage
                    image={getWebpUrl(
                        t("common:SizeGuide:SuitableGlassesImg2"),
                    )}
                />
            </div>

            <p className={styles["title"]}>{t("common:difinations")}</p>
            <table
                style={{
                    width: "90%",
                    borderSpacing: "0",
                    borderCollapse: "collapse",
                    margin: "15px auto 0",
                }}
                className={styles["size-guider-table"]}
                border={1}
            >
                <thead>
                    <tr
                        style={{
                            lineHeight: "0.7rem",
                            textAlign: "center",
                            background: "#efefef",
                        }}
                    >
                        {td([t("common:TOTAL_WIDTH"), t("common:Range")])}
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ lineHeight: "0.7rem", textAlign: "center" }}>
                        {td([t("common:SMALL"), "<129mm"])}
                    </tr>
                    <tr style={{ lineHeight: "0.7rem", textAlign: "center" }}>
                        {td([t("common:MEDIUM"), "129mm-135mm"])}
                    </tr>
                    <tr style={{ lineHeight: "0.7rem", textAlign: "center" }}>
                        {td([t("common:LARGE"), ">135mm"])}
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default SizeGuider;
